var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w100 mobile-activity-root",class:{'mobile-activity':_vm.showAsMobileActivity},style:({height:'100%'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }